import { Tooltip } from 'src/design-system'
import { sub } from 'date-fns'
import { FireSimple } from '@phosphor-icons/react'
import * as React from 'react'
import { store } from 'store/index'
import { Skill } from 'store/modules/skills'
import { User } from 'store/modules/users'

const Fire = () => (
  <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center">
    <FireSimple weight="bold" className="text-white w-3 h-3" />
  </div>
)

const Snowflake = () => (
  <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4971 6.9912C10.5098 7.03877 10.5131 7.08839 10.5066 7.13721C10.5002 7.18604 10.4842 7.23312 10.4596 7.27576C10.435 7.31841 10.4022 7.35579 10.3631 7.38577C10.324 7.41575 10.2795 7.43774 10.2319 7.45048L9.05733 7.76519L9.37207 8.93972C9.38486 8.98731 9.38816 9.03695 9.38176 9.08581C9.37536 9.13467 9.3594 9.18179 9.33478 9.22448C9.31016 9.26716 9.27737 9.30458 9.23828 9.33459C9.1992 9.36459 9.15458 9.3866 9.10698 9.39935C9.05938 9.4121 9.00973 9.41535 8.96088 9.40891C8.91203 9.40246 8.86492 9.38645 8.82226 9.36179C8.7796 9.33713 8.74221 9.3043 8.71225 9.26518C8.68228 9.22606 8.66031 9.18142 8.64761 9.13381L8.27603 7.74708L6.37497 6.64951V8.84467L7.39013 9.85982C7.46046 9.93015 7.49998 10.0255 7.49998 10.125C7.49998 10.2244 7.46048 10.3198 7.39015 10.3902C7.31983 10.4605 7.22445 10.5 7.12499 10.5C7.02553 10.5 6.93014 10.4605 6.85981 10.3902L5.99997 9.53033L5.14013 10.3902C5.0698 10.4605 4.97441 10.5 4.87496 10.5C4.7755 10.5 4.68011 10.4605 4.60979 10.3902C4.53946 10.3198 4.49996 10.2245 4.49996 10.125C4.49997 10.0255 4.53948 9.93015 4.60981 9.85983L5.62497 8.84467V6.64951L3.72391 7.74708L3.35233 9.13381C3.3266 9.22988 3.26375 9.31179 3.17762 9.36152C3.09149 9.41125 2.98913 9.42473 2.89306 9.399C2.79699 9.37326 2.71508 9.31041 2.66535 9.22428C2.61562 9.13815 2.60214 9.03579 2.62788 8.93972L2.94261 7.76519L1.76806 7.45048C1.72045 7.43777 1.67581 7.41581 1.63669 7.38584C1.59757 7.35587 1.56475 7.31849 1.54009 7.27583C1.51542 7.23316 1.49941 7.18606 1.49297 7.13721C1.48652 7.08835 1.48977 7.03871 1.50252 6.99111C1.51527 6.94351 1.53728 6.89889 1.56729 6.8598C1.59729 6.82072 1.63471 6.78792 1.6774 6.76331C1.72008 6.73869 1.7672 6.72272 1.81606 6.71632C1.86492 6.70993 1.91457 6.71322 1.96215 6.72602L3.34894 7.09759L5.25001 6.00001L3.34894 4.90243L1.96215 5.274C1.91457 5.2868 1.86492 5.29009 1.81606 5.28369C1.7672 5.2773 1.72008 5.26133 1.6774 5.23671C1.63471 5.21209 1.59729 5.1793 1.56729 5.14022C1.53728 5.10113 1.51527 5.05651 1.50252 5.00891C1.48977 4.96131 1.48652 4.91167 1.49297 4.86281C1.49941 4.81396 1.51543 4.76685 1.54009 4.72419C1.56475 4.68153 1.59757 4.64415 1.63669 4.61418C1.67581 4.58421 1.72045 4.56225 1.76806 4.54954L2.94261 4.23483L2.62788 3.0603C2.61508 3.01271 2.61178 2.96307 2.61818 2.91421C2.62458 2.86535 2.64054 2.81823 2.66516 2.77554C2.68978 2.73285 2.72257 2.69544 2.76166 2.66543C2.80075 2.63543 2.84537 2.61342 2.89296 2.60066C2.94056 2.58791 2.99021 2.58467 3.03906 2.59111C3.08792 2.59756 3.13502 2.61357 3.17768 2.63823C3.22035 2.66289 3.25773 2.69572 3.2877 2.73484C3.31766 2.77395 3.33963 2.81859 3.35233 2.8662L3.72391 4.25294L5.62497 5.35051V3.15535L4.60981 2.14019C4.53948 2.06987 4.49997 1.97448 4.49996 1.87502C4.49996 1.77557 4.53946 1.68018 4.60979 1.60985C4.68011 1.53952 4.7755 1.5 4.87496 1.5C4.97441 1.5 5.0698 1.5395 5.14013 1.60983L5.99997 2.46969L6.85981 1.60983C6.89464 1.575 6.93598 1.54738 6.98148 1.52854C7.02698 1.5097 7.07574 1.5 7.12499 1.5C7.17423 1.5 7.223 1.5097 7.2685 1.52855C7.31399 1.5474 7.35533 1.57502 7.39015 1.60985C7.42497 1.64467 7.4526 1.68602 7.47144 1.73151C7.49028 1.77701 7.49998 1.82578 7.49998 1.87502C7.49998 1.92427 7.49028 1.97304 7.47143 2.01853C7.45258 2.06403 7.42496 2.10537 7.39013 2.14019L6.37497 3.15535V5.35051L8.27603 4.25294L8.64761 2.8662C8.66035 2.81863 8.68234 2.77404 8.71232 2.73497C8.7423 2.6959 8.77968 2.66312 8.82232 2.63849C8.86497 2.61387 8.91205 2.59788 8.96088 2.59146C9.0097 2.58503 9.05932 2.58828 9.10688 2.60102C9.15445 2.61377 9.19904 2.63575 9.23812 2.66573C9.27719 2.69571 9.30997 2.73309 9.33459 2.77574C9.35922 2.81839 9.3752 2.86547 9.38163 2.91429C9.38806 2.96311 9.38481 3.01273 9.37207 3.0603L9.05733 4.23483L10.2319 4.54954C10.2795 4.56224 10.3241 4.58421 10.3633 4.61418C10.4024 4.64414 10.4352 4.68153 10.4599 4.72419C10.4845 4.76685 10.5005 4.81396 10.507 4.86281C10.5134 4.91166 10.5102 4.96131 10.4974 5.00891C10.4847 5.05651 10.4627 5.10113 10.4327 5.14021C10.4026 5.1793 10.3652 5.21209 10.3225 5.23671C10.2799 5.26133 10.2327 5.27729 10.1839 5.28369C10.135 5.29009 10.0854 5.28679 10.0378 5.274L8.65101 4.90243L6.74994 6.00001L8.65101 7.09759L10.0378 6.72602C10.1339 6.70029 10.2362 6.71377 10.3223 6.7635C10.4085 6.81323 10.4713 6.89514 10.4971 6.9912Z"
        fill="white"
      />
    </svg>
  </div>
)

const Empty = () => (
  <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center" />
)

function findRecentStreak(array: number[]) {
  let currentStreak = 0
  let maxStreak = 0
  let brokenStreak = false

  if (array[array.length - 1] === 0) {
    return 0
  }

  for (let i = array.length - 1; i >= 0; i--) {
    if (array[i] > 0 && !brokenStreak) {
      currentStreak++
      maxStreak = Math.max(maxStreak, currentStreak)
    } else {
      if (currentStreak > 0) brokenStreak = !!array[i + 1]
      currentStreak = 0
    }
  }

  return maxStreak
}

export const Streaks = ({ user, skill }: { user: User; skill: Skill }) => {
  const today = new Date()

  // activity counts for the last 5 weeks
  // [5 weeks ago, 4 weeks ago, 3 weeks ago, 2 weeks ago, last week]
  const activities = Array.from({ length: 5 })
    .map((_, index) => {
      let weekStart: string
      let weekEnd: string

      // last week
      if (index === 0) {
        weekStart = sub(today, { weeks: 1 }).toISOString()
        weekEnd = today.toISOString()
      } else {
        weekStart = sub(today, { weeks: index + 1 }).toISOString()
        weekEnd = sub(today, { weeks: index }).toISOString()
      }

      const activities = store.activities.filteredActivities({
        skillId: skill.id,
        userId: user.id,
        recordType: ['Action', 'Win', 'FeedbackItem', 'Checkin', 'Note'],
        fromDatetime: weekStart,
        toDatetime: weekEnd,
      })

      return activities
    })
    .reverse()

  const activityCounts = activities.map((a) => a.length)

  // 'streak groups'
  // for someone who had 0 updates 5 weeks ago, then updates on weeks 4 and 3, then 0 updates on weeks 2 and 1
  // this would return [[0], [1, 1], [0]] - used to group/background the streaks
  function groupPositiveNumbers(inputArray: number[]) {
    const result = []
    let currentGroup = []

    for (const num of inputArray) {
      if (num > 0) {
        currentGroup.push(num)
      } else {
        if (currentGroup.length > 0) {
          result.push(currentGroup)
        }
        currentGroup = []
        result.push([num])
      }
    }

    if (currentGroup.length > 0) {
      result.push(currentGroup)
    }

    return result
  }

  const activityGroups = groupPositiveNumbers(activityCounts)

  const StreakText = () => {
    // if the last activity count is 0, but the week before was 1, get the number of previous streaks together
    // if the last activity count is 1, get the number of previous streaks together
    // if the activity count before last is 0, say something generic to keep it up

    if (activityCounts.every((count) => count === 0)) {
      return <div>No updates</div>
    }

    if (
      activityCounts[activityCounts.length - 1] === 0 &&
      activityCounts[activityCounts.length - 2] === 0
    ) {
      return <div>No recent updates</div>
    }

    if (activityCounts.every((count) => count > 0)) {
      if (user.isCurrentUser) {
        return <div>Amazing, you&apos;re on a roll!</div>
      }

      return <div>{user.fname} is on a roll!</div>
    }

    if (activityCounts[activityCounts.length - 1] > 0) {
      const streak = findRecentStreak(activityCounts)

      return <div>{streak} week streak!</div>
    }

    if (
      activityCounts[activityCounts.length - 1] === 0 &&
      activityCounts[activityCounts.length - 2] > 0
    ) {
      const activitiesExcludingLast = activityCounts.slice(
        0,
        activityCounts.length - 1
      )
      const streak = findRecentStreak(activitiesExcludingLast)

      let text: string
      if (user.isCurrentUser) {
        if (streak === 1) text = "Don't lose your streak!"
        else text = `Don't lose your ${streak} week streak!`
      } else {
        text = `Help ${user.fname} keep their streak going!`
      }

      return <div>{text}</div>
    }

    return null
  }

  const getTooltipContentForWeek = (index: number) => {
    const weeksAgo = 4 - index

    let weeksAgoText: string
    if (index === 3) weeksAgoText = 'last week'
    else if (index === 4) weeksAgoText = 'this week'
    else weeksAgoText = `${weeksAgo} weeks ago`

    if (activities[index].length === 0) {
      return `No updates ${weeksAgoText}`
    }

    const actionsCompleted = activities[index].filter(
      (activity) =>
        activity.recordType === 'Action' && activity.record.completed
    ).length
    const winsReceived = activities[index].filter(
      (activity) => activity.recordType === 'Win' && activity.record.isWin
    ).length
    const notesLogged = activities[index].filter(
      (activity) => activity.recordType === 'Win' && activity.record.isNote
    ).length
    const feedbackReceived = activities[index].filter(
      (activity) => activity.recordType === 'FeedbackItem'
    ).length
    const checkinsCompleted = activities[index].filter(
      (activity) =>
        activity.recordType === 'Checkin' && activity.record.isFinalised
    ).length
    const checkinsStarted = activities[index].filter(
      (activity) =>
        activity.recordType === 'Checkin' && !activity.record.isFinalised
    ).length

    return (
      <ul className="pl-0 mb-0 text-left">
        Activities from {weeksAgoText}:
        {actionsCompleted > 0 && (
          <li className="ml-4">
            {actionsCompleted} Action{actionsCompleted > 1 && 's'} completed
          </li>
        )}
        {winsReceived > 0 && (
          <li className="ml-4">
            {winsReceived} Win{winsReceived > 1 && 's'} received
          </li>
        )}
        {notesLogged > 0 && (
          <li className="ml-4">
            {notesLogged} Note{notesLogged > 1 && 's'} logged
          </li>
        )}
        {feedbackReceived > 0 && (
          <li className="ml-4">
            {feedbackReceived} set{feedbackReceived > 1 && 's'} of feedback
            received
          </li>
        )}
        {checkinsCompleted > 0 && (
          <li className="ml-4">
            {checkinsCompleted} Checkin{checkinsCompleted > 1 && 's'} completed
          </li>
        )}
        {checkinsStarted > 0 && (
          <li className="ml-4">
            {checkinsStarted} Checkin{checkinsStarted > 1 && 's'}{' '}
            started/updated
          </li>
        )}
      </ul>
    )
  }

  return (
    <div className="flex flex-row items-center gap-x-2">
      <div className="flex flex-row items-center gap-x-1">
        {activityGroups.map((group, index) => {
          if (group.length === 1) {
            if (group[0] === 0) {
              if (index === activityGroups.length - 1)
                return (
                  <Tooltip
                    key={`group-${index}`}
                    content="No updates this week"
                  >
                    <Empty />
                  </Tooltip>
                )
              else
                return (
                  <Tooltip
                    key={`group-${index}`}
                    content={getTooltipContentForWeek(index)}
                  >
                    <Snowflake />
                  </Tooltip>
                )
            } else
              return (
                <Tooltip
                  key={`group-${index}`}
                  content={getTooltipContentForWeek(index)}
                >
                  <Fire />
                </Tooltip>
              )
          } else {
            return (
              <div
                key={`group-${index}`}
                className="bg-orange-100 flex items-center gap-x-1 rounded-l-full rounded-r-full"
              >
                {group.map((_count, countIndex) => (
                  <Tooltip
                    key={`group-${index}-count-${countIndex}`}
                    content={getTooltipContentForWeek(index + countIndex)}
                  >
                    <Fire />
                  </Tooltip>
                ))}
              </div>
            )
          }
        })}
      </div>
      {/* Commenting this out in case we bring it back */}
      {false && (
        <div className="text-gray-600">
          <StreakText />
        </div>
      )}
    </div>
  )
}
